import { ArrowRight } from 'lucide-react';
import React from 'react';

interface HomeCarouselGoToAllPanelProps {
  label: string;
  onClick: () => void;
}

const HomeCarouselGoToAllPanel: React.FC<HomeCarouselGoToAllPanelProps> = ({ label, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className="hidden w-[100px] shrink-0 flex-col items-center justify-center gap-2 self-stretch text-[#3f54a4] max-[767px]:flex"
  >
    <span className="flex h-9 w-9 items-center justify-center rounded-xl border border-blue-200 bg-blue-50 shadow-sm">
      <ArrowRight className="h-4 w-4" />
    </span>
    <span className="text-center font-manrope text-sm font-medium">{label}</span>
  </button>
);

export default HomeCarouselGoToAllPanel;
